import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const SectionHeader = ({ eyebrow, title, description, align = 'left' }) => (
  <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && (
      <div className="eyebrow text-tito-blue/70 mb-4">{eyebrow}</div>
    )}
    <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
      {title}
    </h2>
    {description && (
      <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
        {description}
      </p>
    )}
  </div>
);

export const PageHero = ({ eyebrow, title, description, children }) => (
  <section className="relative overflow-hidden bg-[#003B73] text-white">
    <div className="absolute inset-0 opacity-[0.06]" style={{
      backgroundImage:
        'radial-gradient(circle at 20% 20%, #D4AF37 0, transparent 35%), radial-gradient(circle at 80% 60%, #ffffff 0, transparent 40%)',
    }} />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      {eyebrow && (
        <div className="eyebrow text-tito-gold mb-5">{eyebrow}</div>
      )}
      <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-4xl">
        {title}
      </h1>
      {description && (
        <p className="mt-6 text-base sm:text-lg text-blue-100/90 max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
      {children}
    </div>
    <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-tito-gold/40 to-transparent" />
  </section>
);

export const CTASection = () => (
  <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
    <div className="relative overflow-hidden rounded-sm bg-[#003B73] text-white p-10 md:p-16">
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-tito-gold/20 blur-3xl" />
      <div className="relative grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="eyebrow text-tito-gold">Let&apos;s Grow Together</div>
          <h3 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Ready to take the next step?
          </h3>
          <p className="mt-4 text-blue-100/90 text-base sm:text-lg max-w-xl">
            Whether you need business support, workforce solutions, recruitment assistance, or corporate services — we are ready to help.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <Link to="/contact">
            <Button
              data-testid="cta-section-contact-button"
              className="rounded-sm bg-tito-gold hover:bg-yellow-500 text-[#001E3D] font-semibold h-12 px-7 gap-2"
            >
              Book a Consultation
              <ArrowUpRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);
